import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import { CircularLoaderComponent } from '../LoadingSpinner/LoadingSpinnerComponent';
import CallEventsComponent from './CallEventsComponent';
import { getCallDetailsColumns } from './RemoteDoormanCallsListComponent';

const CallDetailsModalComponent = (props) => {
  const { t } = useTransl();
  const { onGetRemoteDoormanCallById, callId } = props;

  const [callDetails, setCallDetails] = useState(null);

  useEffect(() => {
    const getCallsData = async () => {
      const res = await onGetRemoteDoormanCallById(callId);
      res?.id && setCallDetails(res);
    };
    getCallsData();
  }, []);

  if (!callDetails?.id) return <CircularLoaderComponent />;

  return (
    <div>
      {getCallDetailsColumns(t).map(({ Header, accessor }, i) => (
        <Box key={Header + i} display="flex" width="100%" my="1rem">
          <Box width="15rem" fontWeight="bold">
            {Header}
          </Box>
          <Box>{accessor(callDetails)}</Box>
        </Box>
      ))}
      <Box display="flex" width="100%">
        <Box width="15rem" fontWeight="bold">
          {t('remoteDoorman.callEvents')}
        </Box>
        <Box ml="-4.5rem" mt="-2rem">
          <CallEventsComponent row={callDetails} t={t} />
        </Box>
      </Box>
    </div>
  );
};

CallDetailsModalComponent.propTypes = {
  onGetRemoteDoormanCallById: PropTypes.func.isRequired,
  callId: PropTypes.number.isRequired,
};

export default CallDetailsModalComponent;
